import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery, UseQueryOptions } from 'react-query'
import { reportError } from 'utils/error'
import { WizardTourDismissal } from 'types'
import { sendToApi } from 'api/client'
import { useAuth } from 'hooks/UseAuth'

type Data = { is_dismissed: boolean }

export type Options = UseQueryOptions<Data>

export const useWizardTourDismissals = (identifier: WizardTourDismissal, options?: Options) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const auth = useAuth()

  return useQuery<Data>(
    [currentWorkspaceId, 'wizardTourDismissal', identifier],
    async () => {
      const res = await sendToApi(
        `/users/${auth?.id}/wizard_tour_dismissals/is_dismissed?identifier=${identifier}&workspace_id=${currentWorkspaceId}`,
      )
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Error fetching wizard_tour dismissal')
      }
      return res.data
    },
    {
      enabled: !!auth?.id,
      cacheTime: 60 * 1000 * 60,
      refetchOnWindowFocus: false,
      onError: reportError,
      initialData: { is_dismissed: Boolean(localStorage.getItem(`wizard_tour:${currentWorkspaceId}:${identifier}`)) },
      ...options,
    },
  )
}
